export const headersPlanoAcao = [
  { text: '', width: 1, key: 'offCanvas' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 12, key: 'status' },
  { text: 'Nº Plano de Ação', width: 12, key: 'numeroPa' },
  { text: 'Documento SEI', width: 12, key: 'documentoSei' },
  { text: 'Data Início', width: 12, key: 'dataInicio' },
  { text: 'Data Término', width: 12, key: 'dataTermino' },
  { text: 'Planos de Trab.', width: 12, key: 'nPlanosTrabalho' },
  { text: 'Produtos DAF', width: 12, key: 'nProdutosDaf' },
  { text: 'Valor Total R$', width: 12, key: 'valorTotal' },
];

export const valoresExibidosPlanoAcao: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Plano de Ação
  status: 'Status',
  fiscal: 'Fiscal',
  numeroPa: 'Nº do Plano de Ação',
  dataInicio: 'Data de Início',
  dataTermino: 'Data de Término',
  documentoSei: 'Documento SEI',
  objetivo: 'Objetivo',
  justificativa: 'Justificativa',
  nPlanosTrabalho: 'Nº de Planos de Trabalho',
  nProdutosDaf: 'Nº de Produtos DAF',
  valorTotal: 'Valor Total R$',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorValores: '',
  separadorObservacoes: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
